// Small XYZ gizmo for the 3D curve, drawn with the camera's rotation.
import type { App } from '../app.ts';
import { $ } from './dom.ts';
import { quatToMat3, rotateVec } from '../render/camera.ts';

const COLORS = ['#e1888a', '#9acaac', '#86acdf'];
const NAMES = ['X', 'Y', 'Z'];

export function mountAxis(app: App): void {
  const cv = $<HTMLCanvasElement>('axis');
  const size = 85;
  const draw = () => {
    const show = app.is3d() && !app.state.uiHidden;
    cv.hidden = !show;
    if (!show) return;
    const dpr = window.devicePixelRatio || 1;
    if (cv.width !== size * dpr) { cv.width = size * dpr; cv.height = size * dpr; }
    const g = cv.getContext('2d');
    if (!g) return;
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, size, size);
    g.font = '10px system-ui, sans-serif';
    g.textAlign = 'center';
    g.textBaseline = 'middle';
    g.lineWidth = 1.6;
    const c = size / 2;
    const m = quatToMat3(app.cam.rot);
    const axes = [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
      .map((v, i) => ({ r: rotateVec(m, v[0], v[1], v[2]), i }))
      .sort((a, b) => a.r[2] - b.r[2]);   // back to front
    for (const { r, i } of axes) {
      g.strokeStyle = g.fillStyle = COLORS[i];
      g.globalAlpha = 0.55 + 0.45 * (r[2] + 1) / 2;
      g.beginPath();
      g.moveTo(c, c);
      g.lineTo(c + r[0] * 24, c - r[1] * 24);
      g.stroke();
      g.fillText(NAMES[i], c + r[0] * 34, c - r[1] * 34);
    }
    g.globalAlpha = 1;
  };
  app.listeners.add(draw);
  app.store.subscribe(draw);
  draw();
}
